import { action } from '@ember/object';

import type { Args as BaseArgs } from 'webapp/components/form/custom-ace-editor';
import FormCustomAceEditorComponent from 'webapp/components/form/custom-ace-editor';

interface Args extends BaseArgs {
	onEditorInit: (editor: AceEditor) => void;
}

export default class NotificationsAlertsCustomTemplateEditorComponent extends FormCustomAceEditorComponent<Args> {
	override get options() {
		return {
			theme: 'alert_template',
			mode: 'alert_template',
		};
	}

	@action
	override setupView(node: HTMLElement) {
		super.setupView(node);

		const editor = this.editor;

		if (editor) {
			editor.renderer.setShowGutter(false);
			editor.renderer.setShowPrintMargin(false);
			editor.setHighlightActiveLine(false);
			editor.getSession().setUseWrapMode(true);
			editor.getSession().setWrapLimitRange();

			this.args.onEditorInit(editor);
		}
	}
}
